
import { NgModule } from '@angular/core';
import { FeatureFlagsUseCase, MockFeatureFlagsUseCase } from '../use-case/feature-flags/feature-flags';
import { RealDateTimeService } from './date-time/date-time.real.service';
import { DateTimeService } from './date-time/date-time.service';

// function getMockedAndRealProviders(mockableAssetProviders: ProviderWithProvide[]): Provider[] {
//   if (!checkDevEnvironment(environment)) {
//     return mockableAssetProviders; // No mocking in production
//   }
//   const mockAssetProvides = environment.mockAssetProviders.map((mockProvider) => mockProvider.provide);
//   const realAssetProviders = mockableAssetProviders.filter((provider) => !mockAssetProvides.includes(provider.provide));
//   const providers: Provider[] = environment.mockAssetProviders.concat(realAssetProviders);

//   return providers;
// }

// Default to production assets
@NgModule({
  // TODO: Move this logic to webpack.
  // This is causing problems with the compilation of the app.
  // The environment constant is not defined until after this module is defined
  // which is causing the getMockedAndRealProviders function to throw an error.


  providers:
  // providers: getMockedAndRealProviders(
    [
      { provide: DateTimeService, useClass: RealDateTimeService },
      { provide: FeatureFlagsUseCase, useClass: MockFeatureFlagsUseCase }
    ]
  // )
})
export class MockModule {}
